export default __webpack_public_path__ + "static/media/icon-external-link.ab096d57.svg";